/**
 * Format a date string to dd/mm/yyyy format
 * @param {string|Date} dateInput - Date string or Date object
 * @returns {string} - Formatted date string in dd/mm/yyyy format
 */
export const formatDate = (dateInput) => {
  if (!dateInput) return 'N/A';
  
  try {
    // Handle ISO date strings (YYYY-MM-DD or full ISO)
    let date;
    if (typeof dateInput === 'string') {
      // If it's already in dd/mm/yyyy format, return as is
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateInput)) {
        return dateInput;
      }
      // Handle YYYY-MM-DD format
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
        const [year, month, day] = dateInput.split('-');
        return `${day}/${month}/${year}`;
      }
      // Parse ISO string
      date = new Date(dateInput);
    } else {
      date = dateInput;
    }
    
    if (isNaN(date.getTime())) return dateInput;
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  } catch {
    return dateInput;
  }
};

/**
 * Format a datetime to dd/mm/yyyy HH:mm format
 * @param {string|Date} dateInput - Date string or Date object
 * @returns {string} - Formatted datetime string
 */
export const formatDateTime = (dateInput) => {
  if (!dateInput) return 'N/A';
  
  try {
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return dateInput;
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  } catch {
    return dateInput;
  }
};
